module.exports = __webpack_public_path__ + "img/microsoft.ad23a60a.svg";